import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api'
import { useT } from '@/i18n/I18nProvider'

interface EngineRow {
  id: string; displayName: string; status: string
  pricingPerCallCents: number; supportedLocales: string[]
  deterministic: boolean; sampleSize: number
  lastWeek: { calls: number; avgCostCents: number; totalCostCents: number }
}

export function AdminEnginesPage() {
  const t = useT()
  const engines = useQuery({
    queryKey: ['admin-engines'],
    queryFn: () => apiClient.get<{ data: EngineRow[] }>('/admin/engines'),
  })

  if (engines.isLoading) return <p>{t('common.loading')}</p>
  if (engines.isError || !engines.data) return <p>{t('common.error')}</p>

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-1">{t('admin.engines.title')}</h1>
      <p className="text-xs opacity-70 mb-6">{t('admin.engines.subtitle')}</p>
      <table className="w-full text-sm border-collapse">
        <thead>
          <tr className="text-left opacity-70">
            <th className="py-2 pr-4">engine</th>
            <th className="py-2 pr-4">status</th>
            <th className="py-2 pr-4">deterministic</th>
            <th className="py-2 pr-4">sample size</th>
            <th className="py-2 pr-4">price/call</th>
            <th className="py-2 pr-4">7d calls</th>
            <th className="py-2 pr-4">7d cost</th>
          </tr>
        </thead>
        <tbody>
          {engines.data.data.map((e) => (
            <tr key={e.id} className="border-t" style={{ borderColor: 'var(--color-border)' }}>
              <td className="py-2 pr-4 font-medium">{e.displayName} <span className="text-xs opacity-60">({e.id})</span></td>
              <td className="py-2 pr-4">{e.status}</td>
              <td className="py-2 pr-4">{e.deterministic ? '✓' : '—'}</td>
              <td className="py-2 pr-4">{e.sampleSize}</td>
              <td className="py-2 pr-4">${(e.pricingPerCallCents / 100).toFixed(4)}</td>
              <td className="py-2 pr-4">{e.lastWeek.calls.toLocaleString()}</td>
              <td className="py-2 pr-4">${(e.lastWeek.totalCostCents / 100).toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
